import { useEffect, useRef } from "react";

import useGetUserProperties from "@/users/v3/useGetUserProperties";

import { setEssentialOnlyConsent } from "./dgBannerApi";

const useStudentConsentSuppression = (): void => {
  const { isStudent } = useGetUserProperties();
  const hasSuppressedRef = useRef(false);

  useEffect(() => {
    if (hasSuppressedRef.current || !isStudent) {
      return;
    }

    const suppressed = setEssentialOnlyConsent();
    if (suppressed) {
      hasSuppressedRef.current = true;
    }
  }, [isStudent]);
};

export default useStudentConsentSuppression;
